import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

import Wrapper from 'components/structure/Wrapper';
import useGroup from 'hooks/useGroup';
import Loader from 'components/Loader';
import Urls from 'configs/urls';

function BuildGroup() {
	const {t} = useTranslation();
	const {
		idSession,
		idGroup
	} = useParams();

	const [checkedLine, setCheckedLine] = useState([]);

	const {
		updateBuildDetail,
		getDataGroupToBuild,
		fetching,
		group
	} = useGroup();

	useEffect(() => {
		getDataGroupToBuild(idSession, idGroup);
	}, [idSession, idGroup]);

	let isInit = false;
	if (
		typeof group.group !== 'undefined' &&
		typeof group.group.detail !== 'undefined' &&
		typeof group.group.detail.map === 'function'
	) {
		isInit = true;
	}

	let total = 0;
	if (isInit) {
		group.group.detail.map((detail) => {
			total += detail.count;
		});
	}

	const toogleLine = (lineId) => {
		let tempCheckedLine = [...checkedLine];
		let positionLine = tempCheckedLine.indexOf(lineId);
		if (positionLine !== -1) {
			tempCheckedLine.splice(positionLine, 1)
		} else {
			tempCheckedLine.push(lineId);
		}
		setCheckedLine(tempCheckedLine);
		updateBuildDetail(group.group.detailId, tempCheckedLine)
	}

	useEffect(() => {
		if (isInit && group.group.detailBuild) {
			setCheckedLine(group.group.detailBuild);
		}
	}, [group, isInit])

	return (
		<Wrapper
			className="ToolBuildGroup"
			displayFooter={false}
			title={{
				title: isInit ? group.group.name + ' (' + total + ' ' + t('dominos') + ')' : t('ToolBuildGroup.title')
			}}
		>
			{fetching && (<Loader />)}

			{isInit && (
				<>
					<div className="row header">
						<div className="col-10">
							<img
								src={Urls.baseGroupImage + idSession + '/' + idGroup + '/1'}
							/>
						</div>

						<div className="col-2">
							{group.group.detail.map((detail) => {
								return (
									<div className="card color-info">
										<div className="row">
											<div className="col-auto color-code-wrapper">
												<div
													className="card-img card-img-horizontal color-code"
													style={{
														backgroundColor: detail.color.code
													}}
												/>
											</div>
											<div className="col color-count">
												{detail.count}
											</div>
										</div>
									</div>
								);
							})}

						</div>
					</div>

					<table className="table-build">
						<tbody>
						{group.compactTable && group.compactTable.map((row, indexRow) => {
							return (
								<tr
									key={'tr' + indexRow}
									className={'line' + (checkedLine.indexOf(indexRow) !== -1 ? ' checked' : '')}
								>
									<td className="row-number">{indexRow + 1}</td>
									<td className="checkbox"
									    onClick={() => {
										    toogleLine(indexRow);
									    }}
									>
										<input
											type="checkbox"
											className="done-checkbox"
											checked={checkedLine.indexOf(indexRow) !== -1}
										/>
									</td>
									{row.map((data, indexData) => {
										return (
											<td
												key={'td' + indexData}
												style={{
													backgroundColor: data.color,
													color: data.fontColor
												}}
											>
												{data.count}
											</td>
										);
									})}
								</tr>
							)
						})}
						</tbody>
					</table>
				</>

			)}
		</Wrapper>
	);
}

export default BuildGroup;
